<template>
  <div>
    <Table :columns="columns" :data="tableData">
      <!-- 签约人 -->
      <template slot-scope="{ row }" slot="staffNo">
        <div class="name-status">
          <div class="user-box">
            <i class="dian" :class="{ 'red': row.recommendWorkingState == 0, 'orange': row.recommendIsSus == 1 }"></i>
            <span class="user-name">{{ row.recommendStaffNo }}</span>
            <span v-if="row.recommendStaffNo">/</span>
            <span class="user-name">{{ row.recommend }}</span>
          </div>
        </div>
      </template>
    </Table>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getListData" style="text-align: center; margin-top: 20px" />
  </div>
</template>

<script>
import { common, pageTool } from '@/api/mixins';
export default {
  props: ['actId', 'productType'],
  mixins: [common, pageTool],
  data() {
    return {
      columns: [
        {
          title: '签约人',
          align: 'center',
          minWidth: 250,
          slot: 'staffNo'
        },
        {
          title: '所属团队',
          align: 'center',
          key: 'recommendGroup',
          minWidth: 100
        },
        {
          title: '所属机构',
          align: 'center',
          key: 'recommendOrg',
          minWidth: 150
        },
        {
          title: '签约日期',
          align: 'center',
          key: 'entryTime',
          width: 150,
          render(h, params) {
            let text = params.row.entryTime;
            return <span>{text ? text.substr(0, 10) : '-'}</span>;
          }
        },
        {
          title: '签约奖励',
          align: 'center',
          key: 'activityIncome',
          minWidth: 100
        }
      ],
      tableData: []
    };
  },
  created() {
    this.getListData();
  },
  methods: {
    getListData() {
      let data = {
        reportId: this.$route.query.reportId,
        type: 15,
        activityId: this.actId,
        userId: this.$route.query.userId,
        pageSize: this.pageSize,
        pageNo: this.pageNum
      };
      this.$http({
        url: '/buz/userSalaryDetails/getDetail',
        type: 'POST',
        data
      }).then(res => {
        this.tableData = res.data;
        this.total = res.total;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      vertical-align: middle;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      vertical-align: middle;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
  }
}
</style>
